module.exports = __webpack_public_path__ + "img/19_34.b3010636.png";